// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProfilePicture_mainContainer__v1t2P"};